import { apolloProvider } from '@/modules/GraphQL';
import { apolloProvider as myStageApolloProvider } from '@/modules/myStageGraphQL';
import { DISCOVERY_MATERIAL, DISCOVERY_MATERIAL_MSB } from '@/graphql/discovery';
import { bizmatesApi } from '@/utils/bizmatesApi';

import logger from '@/modules/Logger';
import store from '@/store';

export const DiscoveryMaterialService = {
  msb: async (lessonId) => {
    logger.debug(`[Materials][Discovery] Fetched discovery article from MSB endpoint`, {
      operation: 'materials:get'
    });

    const client = myStageApolloProvider.defaultClient;
    const { data } = await client.query({
      query: DISCOVERY_MATERIAL_MSB,
      variables: {
        student_book_id: parseInt(lessonId)
      }
    });

    if (data?.discoveryArticle) {
      store.commit('material/setHtmlContent', data.discoveryArticle);
    } else {
      logger.error(`[Materials][discovery] Empty result from discovery article material api MSB endpoint`, {
        operation: 'materials:get',
        event_type: 4,
        lesson_id: lessonId
      });
    }
  },
  mbti: async (lessonId) => {
    logger.debug(`[Materials][Discovery] Fetched discovery article from MBTI GraphQL endpoint`, {
      operation: 'materials:get'
    });

    const client = apolloProvider.defaultClient;
    const { data } = await client.query({
      query: DISCOVERY_MATERIAL,
      variables: {
        student_book_id: parseInt(lessonId)
      }
    });

    if (data?.discovery_article) {
      store.commit('material/setHtmlContent', data.discovery_article);
    } else {
      logger.error(`[Materials][discovery] Empty result from discovery article material api`, {
        operation: 'materials:get',
        event_type: 4,
        lesson_id: lessonId
      });
    }
  },

  legacy: async (lessonId) => {
    logger.debug(`[Materials][Discovery] Fetched discovery article from legacy endpoint`, {
      operation: 'materials:get'
    });

    await bizmatesApi.get(`discovery/article.json?b=${lessonId}`, {}, (response) => {
      store.commit('material/setHtmlContent', response.data);
    });
  }
};
